import { useLanguageContext } from "../../../../context/LanguageContext";
import ToolPage from "../../../../pages/calamities/tool/ToolPage";
import { useToolEditRouteValidator } from "../../../validators/calamities/tools/ToolEditRouteValidator";
import { RouteConfig } from "../../RouteConfig";
import useCalamitiesRouteConfig from "../CalamitiesRouteConfig";

/**
 * The route config which contains static information about the route
 * @returns {{ path, label, validator, getPage, getRouteElement }}
 */
function useCalamityToolEditRouteConfig() {
  const { translate } = useLanguageContext();

  return new RouteConfig()
    .setPath("/dashboard/calamities/tools/:tool/edit")
    .setLabel(
      translate("eva.main.entities.states.edit", [
        {
          key: "entities",
          value: translate("eva.main.entities.calamity_tool"),
        },
      ])
    )
    .setValidator(useToolEditRouteValidator())
    .setPage(<ToolPage />)
    .setParent(useCalamitiesRouteConfig());
}

export default useCalamityToolEditRouteConfig;
